<template>
  <q-dialog
    ref="dialog"
    @hide="onDialogHide"
  >
    <q-card
      flat
      bordered
      class="q-dialog-plugin"
      style="max-width: 800px; width: 90vw; white-space: pre-wrap"
    >
      <q-toolbar
        dense
        color="primary"
      >
        <q-avatar>
          <q-icon
            name="mdi-arrow-collapse"
            color="green"
            size="md"
            class="q-pa-none"
          />
        </q-avatar>

        <q-toolbar-title>
          <span class="text-weight-bold">Configuração do Template</span>
        </q-toolbar-title>

        <q-btn
          flat
          round
          dense
          icon="mdi-close"
          data-testid="template-fechar"
          v-close-popup
        />
      </q-toolbar>

      <q-separator inset />

      <q-card-section>
        <div class="row">
          <div class="col column">
            <FieldSelect
              data-testid="template-fila"
              :label="queue.label"
              :state="queue.state"
              :configs="queue.configs"
              :disabled="queue.configs.values.length <= 1"
              type="text"
              is-required
              placeholder="Informação do Template"
              v-model="queue.value"
            />

            <template v-for="param in params">
              <FieldText
                :key="`field-${param.id}`"
                :data-testid="`template-parametro-${param.id}`"
                :label="param.label"
                :state="param.state"
                :configs="param.configs"
                type="text"
                is-required
                placeholder="Informação do Template"
                v-model="param.value"
              />

              <q-separator
                class="col-auto q-pt-none q-mt-none q-mb-md"
                style="height: 1px"
                :key="`separator-${param.id}`"
                v-if="param.state.dirty && param.state.error"
              />
            </template>

            <template v-for="urlParam in urlParams">
              <div
                :key="`url-group-${urlParam.key}`"
                class="col-auto column"
                style="margin-bottom: -4px"
              >
                <FieldText
                  :key="`url-${urlParam.key}`"
                  :data-testid="`template-url-${urlParam.key}`"
                  :label="urlParam.label"
                  :state="urlParam.state"
                  :configs="urlParam.configs"
                  type="text"
                  is-required
                  :placeholder="urlParam.placeholder"
                  v-model="urlParam.value"
                />

                <div
                  class="col-auto text-caption text-grey-7 q-px-sm q-mb-sm"
                  style="margin-top: -10px"
                  :key="`url-hint-${urlParam.key}`"
                >
                  {{ resolveUrlPreview(urlParam) }}
                </div>
              </div>
            </template>
          </div>

          <div
            class="col-5 q-pl-xs row"
            style="border-left: 1px solid #ddd"
          >
            <div class="column">
              <div
                class="col-auto text-bold q-mb-sm"
                v-if="header"
              >
                <q-img
                  v-if="isImage"

                  :src="header"
                  loading="lazy"
                  spinner-color="#ddd"
                  width="80px"
                  height="80px"
                />

                <iframe
                  v-else-if="isDocument"
                  :src="header"
                  width="95%"
                />

                <div
                  v-else-if="isVideo"
                  class="row items-center"
                >
                  <video
                    :src="header"
                    width="95%"
                    controls
                  />
                </div>

                <div v-else>
                  {{ header }}
                </div>
              </div>

              <div
                class="col-auto"
                v-html="body"
              />

              <div
                class="col-auto text-italic q-my-sm"
                v-if="footer"
              >
                {{ footer }}
              </div>

              <div class="col-auto column">
                <template v-for="(btn, index) in btns">
                  <q-btn
                    size="sm"
                    outline
                    color="primary"
                    :key="index"
                    class="col-auto q-mt-xs"
                  >
                    {{ btn }}
                  </q-btn>
                </template>
              </div>
            </div>
          </div>
        </div>
      </q-card-section>

      <q-separator />

      <q-card-actions align="around">
        <q-btn
          flat
          no-caps
          padding="5px 12px"
          color="primary"
          data-testid="template-cancelar"
          @click="onCancelClick"
        >
          Cancelar Envio
        </q-btn>

        <q-btn
          no-caps
          unelevated
          padding="5px 12px"
          color="green-8"
          data-testid="template-enviar"
          @click="handleSendTemplate"
          :label="schedule?'Agendar Template': 'Enviar Template'"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import FieldText from '@/components/fields/FieldText'
import FieldSelect from '@/components/fields/FieldSelect'
import moment from 'moment-timezone'

export default {
  components: {
    FieldText,
    FieldSelect
  },

  props: {
    template: {},
    agent: {},
    schedule: { default: false },
    apiData: { default: null }
  },

  data () {
    const vm = this
    const params = Array.isArray(vm.template.params?.params) ? vm.template.params.params.map(toParamField) : vm.template.params.map(toParamField)
    const message = tryParse(vm.template.message)
    const templateHeader = tryParse(vm.template.header)

    const queue = toParamField({ name: 'queueId', value: 'Fila de Atendimento' })
    const queues = Array.isArray(vm.template.queues) ? vm.template.queues.map(({ queueId, queueName }) => ({ id: queueId, label: queueName })) : []
    queue.configs.values = queues

    const apiQueue = vm.apiData?.queueId
    const preSelectedQueue = queues.length === 1 ? queues[0].id : null
    const isValidApiQueue = apiQueue && queues.some(q => q.id === apiQueue)

    queue.value = isValidApiQueue ? apiQueue : preSelectedQueue

    const urlParams = getTemplateButtons(vm.template)
      .map((btn, index) => ({ btn, index }))
      .filter(({ btn }) => btn.type === 'url' && hasVariable(btn.url))
      .map(({ btn, index }) => toUrlParamField(btn, index))

    if (vm.apiData?.fields) {
      for (const param of params) {
        const normalizedParamId = param.id.replace(/[{}]/g, '')
        const apiValue = vm.apiData.fields[param.id] || vm.apiData.fields[normalizedParamId]

        if (apiValue !== undefined && apiValue !== null) {
          param.value = apiValue
        }
      }

      for (const urlParam of urlParams) {
        const apiValue = vm.apiData.fields[urlParam.key]
        if (apiValue !== undefined && apiValue !== null) urlParam.value = apiValue
      }
    }

    return { params, message, queue, templateHeader, urlParams }
  },

  created () {
    if (this.apiData && this.isFormComplete()) {
      const fields = this.buildFields()
      const queueId = this.queue.value
      this.$nextTick(() => {
        this.$emit('ok', { fields, queueId, header: this.templateHeader })
        this.$emit('hide')
      })
    }
  },

  computed: {
    body () {
      const params = Array.isArray(this.template.params) ? this.template.params : []
      const values = this.params.reduce((acc, item) => ({ ...acc, [item.id]: item.value }), {})
      const queueSelected = this.queue.configs.values.find(q => q.id === this.queue.value)?.label || ''

      let body = toStr(this.message.data) || this.message

      for (const param of params) {
        const value = toStr(values[param.name])
        if (value) body = body.replace(param.name, `<b>${value}</b>`)
      }

      for (const key in vars) {
        const value = toTextValue(key, this.agent, queueSelected)
        if (value) body = body.replaceAll(key, `<b>${value}</b>`)
      }

      return body
    },

    btns () {
      return getTemplateButtons(this.template).map(({ text }) => text)
    },

    header () {
      return toStr(this.message.header || this.templateHeader?.value)
    },

    footer () {
      return toStr(this.message.footer)
    },

    isImage () {
      return this.templateHeader.type === 'IMAGE'
    },

    isDocument () {
      return this.templateHeader.type === 'DOCUMENT'
    },

    isVideo () {
      return this.templateHeader.type === 'VIDEO'
    }
  },

  methods: {
    show () {
      this.$refs.dialog.show()
    },

    hide () {
      this.$refs.dialog.hide()
    },

    onDialogHide () {
      this.$emit('hide')
    },

    handleSendTemplate () {
      const vm = this

      let hasError = false
      const params = Array.isArray(vm.params) ? vm.params.map(clone) : []

      if (!vm.queue.value) {
        hasError = true
        vm.queue.state.dirty = true
        vm.queue.state.error = 'Campo Obrigatório'
      }

      for (const param of params) {
        param.state.dirty = true
        param.state.error = null

        const isEmpty = !String(param.value || '').trim()
        hasError = hasError || isEmpty
        if (isEmpty) param.state.error = 'Campo Obrigatório'
      }

      const urlParams = Array.isArray(vm.urlParams) ? vm.urlParams.map(clone) : []

      for (const urlParam of urlParams) {
        urlParam.state.dirty = true
        urlParam.state.error = null

        const value = String(urlParam.value || '').trim()
        if (!value) {
          hasError = true
          urlParam.state.error = 'Campo Obrigatório'
          continue
        }

        if (!isValidResolvedUrl(urlParam.urlTemplate, value)) {
          hasError = true
          urlParam.state.error = 'Valor inválido: evite espaços e caracteres especiais que quebram o link'
        }
      }

      if (hasError) {
        vm.params = params
        vm.urlParams = urlParams
        return
      }

      const fields = vm.buildFields()
      const queueId = vm.queue.value
      vm.$emit('ok', { fields, queueId, header: this.templateHeader })
      vm.hide()
    },

    onCancelClick () {
      this.hide()
    },

    buildFields () {
      const fields = this.params.reduce((acc, item) => ({ ...acc, [item.id]: item.value }), {})
      for (const urlParam of this.urlParams) {
        fields[urlParam.key] = urlParam.value
      }
      return fields
    },

    resolveUrlPreview (urlParam) {
      const value = String(urlParam.value || '').trim()
      if (!value) return urlParam.urlTemplate
      return urlParam.urlTemplate.replace(/\{\{[^}]*\}\}/, value)
    },

    isFormComplete () {
      if (!this.queue.value) return false

      const paramsOk = this.params.every(param => String(param.value || '').trim().length > 0)
      const urlParamsOk = this.urlParams.every(urlParam => String(urlParam.value || '').trim().length > 0)

      return paramsOk && urlParamsOk
    }
  },

  watch: {
    params: {
      deep: true,
      handler (variables) {
        const params = variables.map(clone)

        for (const param of params) {
          if (!param.state.dirty) return
          const isEmpty = !String(param.value || '').trim()
          param.state.error = isEmpty ? 'Campo Obrigatório' : null
        }

        if (isEqual(params, this.params)) return
        this.params = params
      }
    }
  }
}

const toStr = (val) => String(val || '').trim()
const clone = (val) => JSON.parse(JSON.stringify(val))
const isEqual = (source, target) => JSON.stringify(source) === JSON.stringify(target)
const hasVariable = (url) => /\{\{[^}]*\}\}/.test(String(url || ''))

const isValidResolvedUrl = (urlTemplate, value) => {
  if (/\s/.test(value)) return false
  const resolved = String(urlTemplate || '').replace(/\{\{[^}]*\}\}/, value)
  try {
    const { protocol } = new URL(resolved)
    return protocol === 'http:' || protocol === 'https:'
  } catch {
    return false
  }
}

const getTemplateButtons = (template) => {
  const fromParams = template?.params?.buttons
  if (Array.isArray(fromParams) && fromParams.length) return fromParams

  if (Array.isArray(template?.buttons) && template.buttons.length) return template.buttons

  const message = tryParse(template?.message)
  return Array.isArray(message?.buttons) ? message.buttons : []
}

const toUrlParamField = (btn, index) => ({
  key: `button_url_${index}`,
  label: btn.urlVarDescription || btn.text,
  urlTemplate: String(btn.url || ''),
  value: '',

  state: {
    dirty: false,
    error: null
  },

  configs: {
    fieldRequired: true,
    fieldWidth: 'col-auto'
  }
})
const tryParse = (val) => {
  if (!val) return {}

  try {
    return JSON.parse(val)
  } catch {
    return val
  }
}

const vars = {
  '{{agent}}': 'Nome do Agente',
  '{{queue}}': 'Nome da Fila',
  '{{agentId}}': 'ID do Agente',
  '{{queueId}}': 'ID da Fila',
  '{{queueName}}': 'Nome da Fila',
  '{{agentName}}': 'Nome do Agente',
  '{{contactNumber}}': 'Número do Contato',
  '{{name}}': 'Nome do Contato',
  '{{ticket}}': 'Número do Ticket',
  '{{time}}': 'Horário',
  '{{date}}': 'Data',
  '{{dateTime}}': 'Data e Hora'
}

const toTextValue = (val, agent, queue) => {
  if (!val) return null

  if (val === '{{agent}}') return agent.name
  if (val === '{{agentId}}') return agent.id
  if (val === '{{queue}}') return queue
  if (val === '{{agentName}}') return agent.name
  if (val === '{{name}}') return agent.name
  if (val === '{{time}}') return moment().format('HH:mm')
  if (val === '{{date}}') return moment().format('DD/MM/YYYY')
  if (val === '{{dateTime}}') return moment().format('DD/MM/YYYY HH:mm')

  return val
}

const toParamField = ({ name, value }) => ({
  id: name,
  label: vars[value] || value,
  value: Object.keys(vars).includes(value) ? value : null,

  state: {
    dirty: false,
    error: null
  },

  configs: {
    fieldRequired: true,
    fieldWidth: 'col-auto'
  }
})
</script>
